// Painel Super Master > SMS — ativação por empresa + saldo/recarga
// (infraestrutura de saldo, sem envio real ainda). Atrás de
// platformAuthGuard no backend (sms-credits.controller.ts) — só acessível
// autenticado como PlatformAdmin.
import { platformGet, platformPatch, platformPost } from "@/lib/api/gpsdrive-platform-client";

export interface SmsAccount {
  companyId: string;
  companyName: string;
  enabled: boolean;
  balance: number;
  updatedAt: string;
}

export interface RechargeSmsAccountInput {
  quantity: number;
  totalCost: number;
}

export const gpsDriveSmsCreditsService = {
  list: () => platformGet<SmsAccount[]>("/api/v1/sms-credits"),
  toggle: (companyId: string, enabled: boolean) =>
    platformPatch<SmsAccount>(`/api/v1/sms-credits/${companyId}/toggle`, { enabled }),
  recharge: (companyId: string, input: RechargeSmsAccountInput) =>
    platformPost<SmsAccount>(`/api/v1/sms-credits/${companyId}/recharge`, input),
};
